import { parseShowClusterBqn } from "common/api";
import { asNodes, nodesNamed } from "common/hostnames";

// Turn the BQNs of the cluster into the rows of the table.
export const toBqnRows = (bqns) =>
  bqns.map(
    (
      {
        bqnId,
        ipAddress,
        function: functionBqn,
        onlChanges,
        onlChanged,
        sshPort,
        hostname,
      },
      index
    ) => ({
      id: index,
      BQN: bqnId,
      ADDRESS: ipAddress,
      FUNCTION: functionBqn,
      "ONL-CHANGES": onlChanges,
      "ONL-CHANGED": onlChanged,
      HOSTNAME: hostname || "n/a",
      "SSH-PORT": sshPort,
    })
  );

// The BQNs of the cluster as the nodes of the GUI, named as they were the
// last time each of them was asked for its name.
export const parseBqns = (response) => asNodes(parseShowClusterBqn(response));

// Retrieve the BQNs of the cluster on their own, so that the table can be
// reloaded periodically without going through the cluster context. Only the
// BQN that "show cluster bqn" reports online without a name known already is
// asked for its name: the rest of them are named by the answers kept.
export const retrieveBqns = () =>
  ifCl
    .run("show cluster bqn")
    .then(parseBqns)
    .then(nodesNamed)
    .then(toBqnRows);
